import React from "react";
import type { HotTopicCard } from "../types";
import { Card, Pill } from "../../../components/ui/primitives";

export function HotTopicCardView({
  card,
}: {
  card?: HotTopicCard | null;
}) {
  if (!card) {
    return <Card className="h-[340px] p-5" />;
  }

  return (
    <Card className="relative p-5">
      {card.tag ? (
        <div className="absolute right-4 top-4">
          <Pill
            tone={
              card.tag.tone === "green"
                ? "green"
                : card.tag.tone === "blue"
                ? "blue"
                : "neutral"
            }
          >
            {card.tag.label}
          </Pill>
        </div>
      ) : null}

      <div className="pr-16 text-sm font-semibold leading-snug">{card.title}</div>

      <div className="mt-3 text-xs leading-relaxed text-white/60">{card.body}</div>

      <div className="mt-4 space-y-2">
        {card.bearish ? (
          <div className="rounded-lg border border-rose-400/15 bg-rose-400/10 p-3">
            <div className="text-[11px] font-semibold text-rose-200">Bearish:</div>
            <div className="mt-1 text-[11px] leading-relaxed text-white/60">
              {card.bearish}
            </div>
          </div>
        ) : null}

        {card.bullish ? (
          <div className="rounded-lg border border-emerald-400/15 bg-emerald-400/10 p-3">
            <div className="text-[11px] font-semibold text-emerald-200">Bullish:</div>
            <div className="mt-1 text-[11px] leading-relaxed text-white/60">
              {card.bullish}
            </div>
          </div>
        ) : null}
      </div>

      <div className="mt-3 text-[11px] text-white/45">Sources: {card.sources ?? "—"}</div>
    </Card>
  );
}
